// extracted by mini-css-extract-plugin
export default {"title":"OptionTitle_title__oVnWR"};